import Image from "next/image";
import Link from "next/link";
import { resolveMediaUrl } from "@/lib/media";
import type { TeamMemberList } from "@/lib/dto";

type Props = { member: TeamMemberList; href: string };

/**
 * Compact horizontal team card: avatar + name + position. Used on About Us,
 * distinct from TeamMemberCard's large photo-tile treatment on the team
 * listing page.
 */
export function TeamCard({ member, href }: Props) {
  const img = member.avatar?.url ? resolveMediaUrl(member.avatar.url) : null;

  return (
    <Link href={href} className="group">
      <figure className="image-slot rounded-sm relative aspect-[4/4]">
        {img ? (
          <Image
            src={img}
            alt={member.avatar?.alt || member.name}
            fill
            sizes="300px"
            className="object-cover group-hover:scale-105"
          />
        ) : null}
        <figcaption className="absolute z-10 inset-x-0 bottom-0 px-6 pb-6 pt-16 bg-gradient-to-b from-transparent to-black/20">
          <h3 className="text-white font-extrabold drop-shadow-xl text-2xl">
            {member.name}
          </h3>
          {member.designation ? (
            <span className="mt-0.5 bg-primary text-white font-semibold truncate text-xxs uppercase px-3 py-1.5 rouunded">
              {member.designation}
            </span>
          ) : null}
        </figcaption>
      </figure>
      {/* <span className="relative col-span-1 aspect-square overflow-hidden rounded-full bg-primary-dark">
        {img ? (
          <Image
            src={img}
            alt={member.avatar?.alt || member.name}
            fill
            sizes="120px"
            className="object-cover"
          />
        ) : (
          <span className="flex h-full w-full items-center justify-center font-display text-2xl font-bold text-white/70">
            {member.name.charAt(0)}
          </span>
        )}
      </span>
      <span className="col-span-2 min-w-0">
        <span className="block truncate font-display text-lg font-semibold text-headings">
          {member.name}
        </span>
        {member.designation ? (
          <span className="mt-0.5 block truncate text-sm text-muted">
            {member.designation}
          </span>
        ) : null}
      </span> */}
    </Link>
  );
}
